<template>
    <!-- Loqate address search -->
    <div class="form-group addressfinder clearfix">
        <p>{{getInterfaceText('search_address_intro')}}</p>
        <div class="wrapper-floating-label movelabelonload" style="width:100%;">
            <label for="AddressSearch">{{getInterfaceText('form_address')}}</label>
            <input autocomplete="none" id="AddressSearch" name="AddressSearch" type="text" style="background-color: #fff;" />
        </div>
    </div>

    <div class="modal fade" tabindex="-1" role="dialog" id="AddressValidateFailedModal" aria-modal="true" aria-label="">
        <div class="modal-dialog modal-md modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body" style="overflow:auto;text-align:left;">
                    <div id="validationAddress">
                        <h3 style="font-weight:bold;font-size:2.2rem;" v-html="getInterfaceText('addressValidate_failed_body')"></h3>
                        <div class="row" style="margin-bottom:20px;">
                            <div class="col-md-6" style="padding-bottom: 15px;">
                                <strong>{{getInterfaceText('addressValidate_failed_you_have_filled_in')}}:</strong><br />
                                <span id="street_filled"></span><br />
                                <span id="postalcode_filled"></span>&nbsp;<span id="city_filled"></span><br />
                                <span id="state_filled" v-if="CountryId == 1 || CountryId == 10"></span>
                            </div>
                            <div class="col-md-6">
                                <strong>{{getInterfaceText('addressValidate_failed_suggestion')}}:</strong><br />
                                <span id="street_suggestion"></span><br />
                                <span id="postalcode_suggestion"></span>&nbsp;<span id="city_suggestion"></span><br />
                                <span id="state_suggestion" v-if="CountryId == 1 || CountryId == 10"></span>
                            </div>
                        </div>
                    </div>
                    <div id="validationCountry" style="margin-bottom:20px;">
                        <h3 style="font-weight:bold;font-size:2.2rem;" v-html="getInterfaceText('addressValidate_failed_body')"></h3>
                        <strong>{{getInterfaceText('addressValidate_country_failed_description')}}</strong><br />
                    </div>
                    <div id="validationEmail">
                        <h3 style="font-weight:bold;font-size:2.2rem;" v-html="getInterfaceText('emailValidate_failed_body')"></h3>
                        <strong>{{getInterfaceText('mailValidate_failed_you_have_filled_in')}}:</strong><br />
                        <span id="email_filled"></span>
                    </div>
                    <div id="validationPhone">
                        <h3 style="font-weight:bold;font-size:2.2rem;" v-html="getInterfaceText('phoneValidate_failed_body')"></h3>
                        <strong>{{getInterfaceText('phoneValidate_failed_you_have_filled_in')}}:</strong><br />
                        <span id="phone_filled"></span>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary btn-primary-not-uppercased" data-dismiss="modal" id="btnAddressSearchKeep">{{getInterfaceText('addressValidate_keep')}}</button>
                    <button type="button" class="btn btn-default" data-dismiss="modal" id="btnAddressSearchUpdate">{{getInterfaceText('addressValidate_update')}}</button>
                    <button type="button" class="btn btn-default" data-dismiss="modal" id="btnAddressCancel">{{getInterfaceText('emailValidate_cancel')}}</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import generalMixin from '../mixins/general.js';
    export default {
        name: 'LoqateAddressSearch',
        props: [],
        mixins: [generalMixin],
        data: function () {
            return {
                CountryId: window.countryId
            }
        },
        methods: {
        },
        computed: {
        },
        created() {
            this.interfaceTexts = JSON.parse(document.getElementById('loqateAddressSearchInterfaceTexts').dataset.interfacetexts);
        }
        //mounted() {
        //    window.vueLoqate = this;
        //}
    }
</script>
